import {DataSourceConfig} from './data-source-config.model';
import {DefaultSchemaName} from '@app/views/admin/application-settings/models/data-source-config.model';
import {DataSourceType} from '@app/views/admin/application-settings/models/data-source-type.model';

export class CourseraConfig extends DataSourceConfig {
    isAuthorized: string;
    includeDeletedMembers: boolean;
    isGradeSyncWithoutSsoEnabled: boolean;
    bulkUserInvitation: boolean;
    piiShieldEnabled: boolean;
    invitationDisabled: boolean;
    includeExpiredContracts: boolean;

    constructor(
        public baseUrl: string = '',
        public clientId: string = '',
        public clientSecret: string = '',
        public username: string = '',
        public password: string = '',
        public orgId: string = '',
        public authUrl: string = '',
        public redirectUri: string = '',
        public granularGradeSync: boolean,
        friendlyName: string = ''
    ) {
        super(<DefaultSchemaName>'', friendlyName);
        this.dataSourceType = DataSourceType.Coursera;
    }
}


export const EDIT_DELIVERY_CONFIG_AND_ORGS_MAPPING_NOT_ALLOWED_COURSERA_CLIENT_ID = 'rdkfDoA5dfb2kRyFEs8sxw';
